import { render } from "./IssueGallery.vue?vue&type=template&id=6ddb6998&scoped=true"
import script from "./IssueGallery.vue?vue&type=script&lang=js"
export * from "./IssueGallery.vue?vue&type=script&lang=js"

import "./IssueGallery.vue?vue&type=style&index=0&id=6ddb6998&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1780148264/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddb6998"]])

export default __exports__